import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {SolicitudAhorro} from '../_models/solicitud-ahorro';
import {map} from 'rxjs/operators';
import {ExcelAvance} from '../_models/excel-avance';
import {MatrizidentidadValidaciones} from "../_models/matrizidentidad-validaciones";

@Injectable({
  providedIn: 'root'
})
export class SolicitudAhorrosService {
  private rutServiciosSolicitudCuentaAhorro = AppSettings.rutServiciosAUTOGES + '/api/solicitudAhorros/';

  constructor(private httpClient: HttpClient,
              private autenticacionService: AutenticacionService) {
  }

  listado(): Observable<SolicitudAhorro[]> {
    return this.httpClient.get(this.rutServiciosSolicitudCuentaAhorro).pipe(map(res => res as SolicitudAhorro[]));
  }

  obtener(idSolicitudAhorro: string): Observable<SolicitudAhorro> {
    return this.httpClient.get(this.rutServiciosSolicitudCuentaAhorro + idSolicitudAhorro).pipe(map(res => res as SolicitudAhorro));
  }

  agregar(solicitud: SolicitudAhorro): Observable<SolicitudAhorro> {
    solicitud.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.post(`${this.rutServiciosSolicitudCuentaAhorro}`, solicitud).pipe(map(res => res as SolicitudAhorro));
  }

  actualizar(solicitud: SolicitudAhorro): Observable<any> {
    solicitud.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.put(this.rutServiciosSolicitudCuentaAhorro, SolicitudAhorro).pipe(map(res => res as any));
  }

  solicitudesPendienteCuentasAhorro(busqueda: any) {
    return this.httpClient.post(this.rutServiciosSolicitudCuentaAhorro + 'solicitudesPendienteCuentasAhorro', busqueda).pipe(map((res: any) => {
      const datos = {paginas: res.totalPages, total: res.totalElements, data: res.content as any[]};
      return datos;
    }));
  }

  countPendienteSolicitudAhorro() {
    return this.httpClient.get(this.rutServiciosSolicitudCuentaAhorro + 'countPendienteSolicitudAhorro/').pipe(map(res => res as any));
  }

  verificarIntegracion () {
    return this.httpClient.get(`${this.rutServiciosSolicitudCuentaAhorro}lanzarAprobacion/usuario/${this.autenticacionService.obtenerIdUsuarioLogueado()}` ).pipe(map( resp => resp as ExcelAvance));
  }

  aprobarSolicitudCuentaAhorro (obj: any) {
    return this.httpClient.post(`${this.rutServiciosSolicitudCuentaAhorro}` + 'aprobacionSolicitud', obj ).pipe(map( resp => resp as any));
  }

  validarMatrizIdentidad(idSuc: string) {
    return this.httpClient.get(`${this.rutServiciosSolicitudCuentaAhorro}validarMatrizIdentidad/suc/${idSuc}`).pipe(map(resp => resp as MatrizidentidadValidaciones));
  }

  lanzarCreacionCuentaAhorro(data:any){
    const usuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    const obj = {
      ...data,
      idUsuario: usuario
    };
    return this.httpClient.post(`${this.rutServiciosSolicitudCuentaAhorro}lanzarCreacionCuentaAhorro`, obj ).pipe(map( resp => resp as any));

  }

}
